import { Dashboard } from "api/model/dashboard/Dashboard";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { easasConfirmDialog } from "components/fragments/easas-global-fragment/EasasGlobalConfirmDialog";
import React from "react";
import { handleAddNewTab } from "./ImportDashboardOrTab";

interface DashboardEditorProps {
  updateQuery: any;
  dashboard: Dashboard;
  setDashboard: (dashboard: Dashboard) => void;
  tabId: number;
  triggerTabTitleChangeDialog: () => void;
  setReorderTabsDialogVisibility: (reorderTabsDialogVisibility: boolean) => void;
  setTabConfiguratorVisibility: (tabConfiguratorVisibility: boolean) => void;
  setIsImportDashboardDialogVisibility: (isImportDashboardDialogVisible: boolean) => void;
  setAddNewGroupDialogVisibility: (addNewGroupDialogVisibility: boolean) => void;
  isGroupReorderEnabled: boolean;
  setIsGroupReorderEnabled: (isGroupReorderEnabled: boolean) => void;
  setIsCreateDatasetDialogVisible: (isCreateDatasetDialogVisible: boolean) => void;
}

const DashboardEditor = (props: DashboardEditorProps) => {
  const navigate = useNavigate();

  const removeTabConfirmation = () => {
    easasConfirmDialog({
      icon: "pi pi-exclamation-triangle",
      header: "Remove Tab",
      confirmedCallback: handleRemoveSelectedTab,
    });
  };

  const handleRemoveSelectedTab = () => {
    const updatedCurrentDashboard = {
      ...props.dashboard,
      dashboardTabsJs: [
        ...props.dashboard.dashboardTabsJs.slice(0, props.tabId),
        ...props.dashboard.dashboardTabsJs.slice(props.tabId + 1),
      ],
    };
    props.setDashboard(updatedCurrentDashboard);
    navigate(`/dashboard/${props.dashboard?.id}/tab/0`);
  };

  return (
    <div className="flex flex-row justify-content-between">
      <div className="flex flex-column gap-2">
        <div>Tabs:</div>
        <div className="flex flex-row gap-2 mb-3">
          <Button
            icon="pi pi-save"
            tooltip="Save dashboard"
            className="p-button-info"
            tooltipOptions={{ position: "bottom" }}
            onClick={() => props.updateQuery.mutate(props.dashboard)}
          />
          <Button
            icon="pi pi-plus"
            tooltip="Add new tab"
            className="p-button-success"
            tooltipOptions={{ position: "bottom" }}
            onClick={() => handleAddNewTab(props.dashboard, props.setDashboard, "Tab")}
          />
          <Button
            tooltip="Change tab title"
            icon="pi pi-pencil"
            tooltipOptions={{ position: "bottom" }}
            className="p-button-warning"
            onClick={props.triggerTabTitleChangeDialog}
          />
          <Button
            tooltip="Reorder tabs"
            icon="pi pi-arrow-right-arrow-left"
            className="p-button-secondary rotate-90"
            style={{ height: "3.1rem", width: "3.15rem", marginTop: "0.1rem" }}
            onClick={() => props.setReorderTabsDialogVisibility(true)}
            tooltipOptions={{ position: "bottom" }}
          />
          <Button
            icon="pi pi-cog"
            tooltip="Configure Tab"
            className="p-button-warning p-button"
            onClick={() => props.setTabConfiguratorVisibility(true)}
            tooltipOptions={{ position: "bottom" }}
          />
          <Button
            icon="pi pi-trash"
            tooltip="Remove tab"
            tooltipOptions={{ position: "bottom" }}
            className="p-button-danger"
            onClick={removeTabConfirmation}
          />
        </div>
      </div>
      <div className="flex flex-column gap-2">
        <div>Datasets:</div>
        <div className="flex flex-row gap-2">
          <Button
            icon="pi pi-plus"
            tooltip="Create new dataset"
            className="p-button-success"
            tooltipOptions={{ position: "bottom" }}
            onClick={() => props.setIsCreateDatasetDialogVisible(true)}
          />
        </div>
      </div>
      <div className="flex flex-column gap-2">
        <div>Import:</div>
        <div className="flex flex-row gap-2">
          <Button
            tooltip="Import dashboard or tab"
            icon="pi pi-file-import"
            tooltipOptions={{ position: "bottom" }}
            className="p-button-success"
            onClick={() => props.setIsImportDashboardDialogVisibility(true)}
          />
        </div>
      </div>
      <div className="flex flex-column gap-2">
        <div>Components Groups:</div>
        <div className="flex flex-row justify-content-end gap-2">
          <Button
            tooltip="Add new components group"
            icon="pi pi-plus"
            className="p-button-success"
            tooltipOptions={{ position: "bottom" }}
            onClick={() => props.setAddNewGroupDialogVisibility(true)}
          />
          <Button
            tooltip="Reorder components groups"
            icon="pi pi-arrow-right-arrow-left"
            tooltipOptions={{ position: "bottom" }}
            className={`${props.isGroupReorderEnabled ? "p-button-warning rotate-90 border" : "p-button-secondary rotate-90"}`}
            onClick={() => props.setIsGroupReorderEnabled(!props.isGroupReorderEnabled)}
          />
        </div>
      </div>
    </div>
  );
};

export default DashboardEditor;
